// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3WBwX","selected":"Chip_selected__3mP2I"};